import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const getTeamManagementModuleRoutes: ModuleRoutesComponentInterface = () => [
  {
    id: ModuleConstants.TEAM_MANAGEMENT,
    route: '/teams',
    title: ScreenNames.TEAM_MANAGEMENT,
    icon: generateImage({
      noScale: true,
      name: 'team',
      alt: 'team',
      className: 'w-4 h-4',
    }),
    component: ComponentsMap.TEAM_MANAGEMENT,
  },
];

export default getTeamManagementModuleRoutes;
